export default "__VITE_ASSET__V2YW9gcV__"